export default function PreviewGroupService($http, $q, CurrentUserService) {
  const vm = this;
  vm.userGroups = [];
  vm.create = create;
  vm.update = update;
  vm.show = show;
  vm.destroy = destroy;
  vm.initUserGroups = initUserGroups;
  vm.updateUserGroups = updateUserGroups;

  function create(ids, name) {
    return $http.post('/preview_groups', {
      previewGroup: { creativePreviewIds: ids, name }
    });
  }

  function update(groupId, ids, name) {
    return $http.patch(`/preview_groups/${groupId}`, {
      previewGroup: { creativePreviewIds: ids, name }
    });
  }

  function show(id) {
    return $http.get(`/preview_groups/${id}`);
  }

  function destroy(id) {
    return $http.delete(`/preview_groups/${id}`);
  }

  function initUserGroups() {
    return CurrentUserService.get().then(user => {
      if (user) {
        return vm.updateUserGroups();
      }
    });
  }

  function updateUserGroups() {
    return $http.get('/preview_groups').then(response => {
      vm.userGroups = response.data;
    });
  }

  return vm;
}

PreviewGroupService.$inject = ['$http', '$q', 'CurrentUserService'];
